import React from 'react';

const AboutUs = () => (
	<div className="container main">
		<h2>消費者製品安全作業部会について</h2>
		<hr/>
		<div className="row">
			<div className="col-sm-6">
				<h4>OECD消費者製品安全作業部会</h4>
				<p>
					<em>GlobalRecalls</em>ポータルは<a href="http://www.oecd.org/sti/consumer/consumer-product-safety.htm">OECD消費者製品安全作業部会</a>が開発したものです。
					その任務は、以下の方法により情報共有を改善し、世界中の製品安全市場の監視、執行、規制当局間の協力関係をさらに促進することに重点を置いています。
				</p>
				<ul className={'rss-feed-options'}>
					<li>安全性の問題の早期特定</li>
					<li>実施状況と政策の動向の共有</li>
					<li>一貫した方法で安全上の懸念に対処</li>
					<li>グローバルおよび地域フォーラムのサポート</li>
				</ul>
				<p>
					作業部会の重要な成果のひとつは<a href="https://legalinstruments.oecd.org/en/instruments/OECD-LEGAL-0459">消費者製品の安全におけるOECDの勧告</a>であり、それは国内および国際的なレベルにおける消費者製品安
					全の枠組みの中核となるべき基本方針を概説し、GlobalRecallsポータルのさらなる利用を奨励しています。
					また、作業部会は、より効果的な製品リコールを実現するために、政府や企業向けに他の多くの資料を作成しており、これらは同<a href="https://www.oecd.org/digital/consumer/consumer-product-safety.htm">ウェブサイ</a>トで閲覧することができます。
				</p>
			</div>
			<div className="col-sm-6">
				<h4 className="hidden-xs">&nbsp;</h4>
				<p>
					作業部会は<a href="https://www.oecd.org/sti/consumer/">OECD消費者政策委員会</a>の管轄下にあり、両機関は消費者保護に関する問題で定期的に協力し、多くの共同プロジェクトやイベントを開催しています。
				</p>
				<p>
					さらに、作業部会は製品安全分野に積極的に取り組んでいる国際組織と緊密に協力しており、そうした機関には東南アジア諸国連合（ASEAN）、
					欧州委員会（EC）、消費者保護及び執行のための国際ネットワーク（ICPEN）、
					国際消費者製品健康・安全機構（ICPHSO）、米州機構（OAS）、国連貿易開発会議（UNCTAD）
					などが含まれます。また、作業部会は、多くのOECDパートナー経済組織と緊密な関係を維持しています。
				</p>
			</div>
		</div>
		<hr/>
		<div className="row">
			<div className="col-sm-6">
				<h4>お問い合わせ</h4>
				<p>
					GlobalRecallsポータルに関するご質問やご意見は、OECD事務局（<a href="mailto:GlobalRecallsdata@oecd.org">GlobalRecallsdata@oecd.org</a>）までお問い合わせください。
				</p>
			</div>
		</div>
	</div>
);

export default AboutUs;



// WEBPACK FOOTER //
// ./src/views/static/ja/about-us.js